import { DeviceGroup } from "luxedo-data"
import {
	closeOverlay,
	openConfirmOverlay,
	openMultiButtonOverlay,
	openOverlay,
	openPopupOverlay,
} from "overlay"
import GroupEditor from "./GroupEditor.svelte"
import { GroupEditorController } from "./GroupEditorController"
import { Toast } from "toaster"
import type { GroupOverlapController } from "./steps/blend/GroupOverlapController"
import { Responsive } from "responsive"

export function openGroupEditorOverlay(group: DeviceGroup) {
	const clearGrid = async (e: BeforeUnloadEvent) => {
		e.preventDefault()
		await GroupEditorController.Grid.deactivate()
	}

	const confirmClose = (ignoreController?: boolean) => {
		window.removeEventListener("beforeunload", clearGrid)

		if (!ignoreController) {
			GroupEditorController.Grid.deactivate()
			GroupEditorController.reset()
			closeOverlay(GroupEditorController.overlayID, true)
		}
	}

	const beforeClose = () => {
		return new Promise<void>((res, rej) => {
			if (group.dirty) {
				const overlayID = openMultiButtonOverlay({
					prompt: [
						"Are you sure you want to close the group editor?",
						"Any unsaved changes will be lost!",
					],
					buttons: [
						{
							text: "Close",
							onClick: () => {
								closeOverlay(overlayID)
								confirmClose()
								res()
							},
							className: "warn",
						},
						{
							text: "Cancel",
							onClick: () => {
								closeOverlay(overlayID)
								rej()
							},
							className: "cancel",
						},
						{
							text: "Save and Close",
							onClick: async () => {
								Toast.text("Saving group configuration...")
								closeOverlay(overlayID)
								await GroupEditorController.save(true)
								confirmClose(true)
							},
						},
					],
				})
			} else res()
		})
	}

	if (!(group instanceof DeviceGroup)) throw new Error("Must open with a device group")

	GroupEditorController.activate(group, () => confirmClose(true))
	GroupEditorController.overlayID = openOverlay(GroupEditor, {
		classHeading: "no-underline",
		// large
		classOverlay: "no-pad can-grow full-sized",
		beforeClose,
	})

	// show warning on mobile
	if (Responsive.isMobile) {
		setTimeout(() => {
			openPopupOverlay({
				prompt: [
					"For the best experience, we recommend configuring groups on a computer instead of a smartphone.",
				],
				buttonText: "OK",
			})
		})
	}

	window.addEventListener("beforeunload", clearGrid)
}

export type OverlapInstance = GroupOverlapController.OverlapInstance
